export const ActionableItemsFilterConfig = [
  {
    fieldName: "status",
    title: "Status",
    filterType: "SingleSelect",
    nameKey: "label",
    valueKey: "key",
    orderingVal: "order",
    apiUrl: `field_options/?content_type=actionableitems&field_name=status&flat=true&`,
    permission: "",
  },
  {
    fieldName: "assigned_to_me",
    title: "Assigned To Me",
    filterType: "SearchOptionGroup",
    customFalseLabel: "No",
    customTrueLabel: "Yes",
    permission: "",
  },
  {
    fieldName: "acting_user",
    title: "Assigned To",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Users",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/assignable-users/?`,
    permission: "",
  },
  {
    fieldName: "assigned_role",
    title: "Assigned Role",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Roles",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/user-roles/?`,
    permission: "",
  },
  {
    fieldName: "due_date",
    title: "Due Date",
    filterType: "DateRange",
    permission: "",
  },
  {
    fieldName: "on_provider",
    title: "Provider",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Providers",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/providers/?`,
    permission: "",
  },
  {
    fieldName: "on_firm",
    title: "Law Firm",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Law Firms",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/law-firms/?`,
    permission: "",
  },
  {
    fieldName: "completed_at",
    title: "Completed At",
    filterType: "DateRange",
    permission: "",
  },
  {
    fieldName: "completed_by",
    title: "Completed By",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Users",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/assignable-users/?`,
    permission: "",
  },
  {
    fieldName: "action_type",
    title: "Type",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Action Types",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/action_types/?`,
    permission: "",
  },
];

export const defaultFilterParams = {
  status: "pending",
  assigned_to_me: "true",
  ordering: "due_date",
};
